const footer = {
  copyright: "저작권 © 2022년 HitPaw 주식회사 모든 권한이 예약되었습니다.",
};

export default footer;
